import type {ReactElement} from 'react';
import {useEffect} from 'react';
import {useMap} from '@vis.gl/react-google-maps';
import type {GoogleMapHandlerProps} from './google-map-handler.types';

export function GoogleMapHandler({place, marker}: GoogleMapHandlerProps): ReactElement | null {
  const map = useMap();

  useEffect(() => {
    if (!map || !place || !marker || !place.latitude || !place.longitude) return;

    if (place.viewport) {
      map.fitBounds(place.viewport);
    }
    marker.position = {
      lat: place.latitude,
      lng: place.longitude,
    };
  }, [map, place, marker]);

  return null;
}
